var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C16.095 5 19.5947 7.71373 21 11.5446C19.5953 15.3767 16.0953 18.0909 12 18.0909C7.90503 18.0909 4.40525 15.3772 3 11.5464C4.40468 7.71418 7.9047 5 12 5ZM12 7.45455C9.74065 7.45455 7.90909 9.28611 7.90909 11.5455C7.90909 13.8048 9.74065 15.6364 12 15.6364C14.2593 15.6364 16.0909 13.8048 16.0909 11.5455C16.0909 9.28611 14.2593 7.45455 12 7.45455ZM12 9.09091C13.3556 9.09091 14.4545 10.1898 14.4545 11.5455C14.4545 12.9011 13.3556 14 12 14C10.6444 14 9.54545 12.9011 9.54545 11.5455C9.54545 10.1898 10.6444 9.09091 12 9.09091Z",
    fill: "#75593A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.18629a2ff47f225602b36273f4476389.svg";
export { ForwardRef as ReactComponent };